$(function(){
	$('.shop-section__title').on('click',function(){
		$(this).toggleClass('active').next().slideToggle();
	});
	//$('#shop-lease').find('.shop').clone().appendTo('#shop-trade');
});